module.exports = __webpack_public_path__ + "img/watermark small.b7cf2019.png";